module.exports = __webpack_public_path__ + "static/media/Group190.6ed84275.png";